import { createAction } from "@reduxjs/toolkit";
import { UploadAction } from "./index";

export const enqueueUpload = createAction<UploadAction>("uploads/enqueue");
